import * as React from 'react';
import { ProductionRun } from '../models/schedule/production-run';
import { CellMetric } from '../models/shared/metric-base';
import { DragCell } from './DragCell';

interface IProps {
    readonly: boolean;
    run: ProductionRun;
    nonMetricPropCount : number;
    metricBeingSelected: any;
    onTouchStart: any;
    onTouchMove: any;
    index: number;
    isCellSelected: any;
    cells: any;
    fullRowSelected: boolean;
    showOnlyQuantites: boolean|undefined;
}

const METRICS_BEFORE_SPACING_CELL = 22;

export const MetricRow = (props: IProps) => {

    const {
        run
    } = props;

    let actualClass = 'task-selectable';
    actualClass += (run.isChecked) ? ' highlight' : '';
    // actualClass += (isSelecting) ? ' dragging' : '';
    // actualClass += (isSelected) ? ' selected-already' : '';

    if (props.fullRowSelected) {
        actualClass += " full-row-cut-state";
    }

    return <tr
        key={`upprtr-${run.tmpClientId}`}
        className={`production-task-metric-row ${actualClass}`}>
        {
            props.cells && props.cells.length > 0
                ? props.cells.map((itm: CellMetric, idx : number) => {
                    return <React.Fragment key={`metric-row-cell-${props.run.tmpClientId}-${idx}}`}>
                        {
                            idx === (METRICS_BEFORE_SPACING_CELL + props.nonMetricPropCount)
                                ? <DragCell 
                                    className="spacer-column"
                                    disabled={true}
                                    beingSelected={ props.metricBeingSelected(props.index, idx) }
                                    selected={ props.isCellSelected(props.index, idx) }
                                    onTouchStart={ props.onTouchStart }
                                    onTouchMove={ props.onTouchMove }
                                    status={ itm.status }
                                    type={ itm.cellType }
                                    value={ itm.value }
                                    showonlyquantites={ props.showOnlyQuantites }
                                />
                                : <DragCell
                                    className=""
                                    disabled={ false }
                                    beingSelected={ props.metricBeingSelected(props.index, idx) }
                                    selected={ props.isCellSelected(props.index, idx) }
                                    onTouchStart={ props.onTouchStart }
                                    onTouchMove={ props.onTouchMove }
                                    status={ itm.status }
                                    type={ itm.cellType }
                                    value={ itm.value }
                                    showonlyquantites={ props.showOnlyQuantites }
                                />
                        }                          
                    </React.Fragment>;
                })
                : null
        }

    </tr>;

};
